import { cn } from '@/lib/cn';

/**
 * Fint's mark: one stroke. The line rises from the lower left, dips once,
 * reaches the top-right corner and carries on as the hexagon itself, all the
 * way round, stopping just short of where it arrived. The open corner is the
 * idea - the line does not escape the box, it builds it.
 *
 * The same path as public/icon.svg and docs/brand/fint-mark.svg, and the
 * polyline scripts/make-icons.js rasterises: one design, three renderings.
 * Drawn in `currentColor`, so it takes the text colour of wherever it sits -
 * `text-primary` in the shell, white on a blue tile - and never carries a
 * pasted hex of its own.
 */
export const FINT_MARK_PATH =
  'M19 70 35 54 45 61 88.1 28 88.1 72 50 94 11.9 72 11.9 28 50 6 75.1 20.5';

export function FintMark({ className, title }: { className?: string; title?: string }) {
  return (
    <svg
      viewBox="0 0 100 100"
      className={cn('shrink-0', className)}
      fill="none"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
    >
      {title ? <title>{title}</title> : null}
      <path d={FINT_MARK_PATH} stroke="currentColor" strokeWidth="7" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

/** The mark beside the name, as the sidebar and the sign-in pages show it. */
export function FintWordmark({ className, markClassName }: { className?: string; markClassName?: string }) {
  return (
    <span className={cn('inline-flex items-center gap-2 font-semibold tracking-tight', className)}>
      <FintMark className={cn('size-7', markClassName)} />
      <span>Fint</span>
    </span>
  );
}
